module.exports = __webpack_public_path__ + "static/aaron_2-200286a183eb3cf1962ccd83bb575b74.gif";